import { CommonPipesModule } from 'app/shared/pipes/common-pipes.module';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { NgModule, Pipe, PipeTransform } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { AgmCoreModule } from '@agm/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { JustgageModule } from 'angular2-justgage';
import {
    EditorModule, TabViewModule, CalendarModule
    , DataTableModule, MenubarModule, ConfirmDialogModule, ConfirmationService
} from 'primeng/primeng';

import { SharedModule } from 'app/shared/shared.module';
import { AutoCompleteModule } from 'primeng/primeng';
import { DomSanitizer } from '@angular/platform-browser';
import { EntityAuditComponent } from 'app/entities/audit/entity-audit.component';
import { AuditDetailsComponent } from 'app/entities/audit/auditdetails/audit-details.component';
import { AddAuditInformationComponent } from 'app/entities/audit/addauditinformation/add-audit-information.component';
import { EntityAuditService } from 'app/entities/audit/entity-audit.service';

@NgModule({
    declarations: [
        EntityAuditComponent,
        AuditDetailsComponent,
        AddAuditInformationComponent
    ],
    imports: [
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyBw6zrtGzSpNfaPR1BOfMnqUnH6cONDyLk',
            libraries: ['places']
        }),
        MaterialModule.forRoot(),
        ReactiveFormsModule,
        BrowserModule,
        FormsModule,
        DataTableModule,
        FlexLayoutModule,
        SharedModule,
        CalendarModule,
        TabViewModule,
        JustgageModule,
        MenubarModule,
        ConfirmDialogModule,
        EditorModule,
        AutoCompleteModule,
        InfiniteScrollModule,
        CommonPipesModule
    ],
    exports: [
        EntityAuditComponent,
        AddAuditInformationComponent
    ],
    entryComponents: [
        AddAuditInformationComponent
    ],
    providers: [EntityAuditService]
})

/**
 * Main module for the entity monitoring tab management.
 *
 * @author jagpreet.singh@vernuso.com (Jagpreet Singh)
*/
export class EntityAuditModule { }



// WEBPACK FOOTER //
// ./src/app/entities/audit/entity-audit.module.ts